import { Grid } from "@material-ui/core";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router-dom";

import API from "../../../../api";
import Can, { check } from "../../../../components/Can";
import InternalLayout from "../../../../components/layouts/InternalLayout";
import NavigationTabs from "../../../../components/NavigationTabs";
import { getRoles, getUserType } from "../../../../modules/auth";
import {
  fetchFactoringProfile,
  fetchUser,
  getFactorClient,
  getUser,
  getUserId
} from "../../../../modules/factoringClient";
import { openSnackbar as showSnackbar } from "../../../../modules/ui";
import roleRules from "../../../../roleRules";
import getTabs from "../tabs";
import ConnectedIntegrations from "./ConnectedIntegrations";
import TmsCard from "./TmsCard";

const FactorClientIntegrations = ({
  match
}: RouteComponentProps<{ id: string }>): JSX.Element => {
  const dispatch = useDispatch();
  const factoringClient = useSelector(getFactorClient);
  const user = useSelector(getUser);
  const userId = useSelector(getUserId);
  const userType = useSelector(getUserType);
  const roles = useSelector(getRoles);
  const { id } = match.params;
  const tabs = getTabs(id, get(factoringClient, "allow_self_finance_fr"));

  useEffect(() => {
    dispatch(fetchFactoringProfile(id));
  }, [id]);

  useEffect(() => {
    if (userId) dispatch(fetchUser(userId));
  }, [userId]);

  const openSnackbar = useCallback(
    (variant: string, message: string): void => {
      dispatch(showSnackbar(variant, message));
    },
    [dispatch]
  );

  const saveTms = async (tms: string): Promise<void> => {
    await API.factoring.updateProfile(id, { tms });
    await dispatch(fetchFactoringProfile(id));
  };

  if (isEmpty(userId)) return <div />;

  return (
    <Can
      perform="admin-factorclient-integrations:view"
      yes={(): JSX.Element => (
        <InternalLayout title="Integrations">
          <Grid container direction="column" spacing={24}>
            <Grid item style={{ width: "100%" }}>
              <NavigationTabs
                tabs={tabs}
                value={tabs.findIndex(tab => tab.value === "integrations")}
              />
            </Grid>
            <Grid item style={{ width: "100%" }}>
              <TmsCard
                factoringId={id}
                savedTmsId={get(factoringClient, "tms") || ""}
                canEdit={userType === "admin"}
                onSave={saveTms}
                openSnackbar={openSnackbar}
              />
            </Grid>
            <ConnectedIntegrations
              factoringId={id}
              isBroker={get(user, "type") === "broker"}
              allowed={(permission: string): boolean =>
                check(roleRules, roles, permission)
              }
              openSnackbar={openSnackbar}
            />
          </Grid>
        </InternalLayout>
      )}
    />
  );
};

export default FactorClientIntegrations;
